export function extractCardholderName(
  name = ""
): { firstName: string; lastName: string } {
  if (!name) return { firstName: "", lastName: "" };

  const cleaned = name.replace(/[.,]/g, " ").replace(/\s+/g, " ").trim();
  const prefixes = ["mr", "mrs", "ms", "mx", "dr", "prof"];
  const suffixes = ["jr", "sr", "ii", "iii", "iv", "phd", "md"];

  const parts = cleaned.split(" ");
  while (parts.length && prefixes.includes(parts[0].toLowerCase()))
    parts.shift();
  while (
    parts.length &&
    suffixes.includes(parts[parts.length - 1].toLowerCase())
  )
    parts.pop();

  if (parts.length === 0) return { firstName: "", lastName: "" };
  if (parts.length === 1) return { firstName: parts[0], lastName: "" };

  return { firstName: parts[0], lastName: parts[parts.length - 1] };
}
